import { useEffect, useState } from "react";
import { t } from "i18next";
import MultiCheckSelect from "../../option-select/MultiCheckSelect";
import { reactSelectTheme } from "../../option-select/reactSelectTheme";

interface WorkorderSafetyDiagSelectProps {
  value?: string[];
  onChange?: (values: string[]) => void;
  disabled?: boolean;
}

/**
 * WorkorderSafetyDiagSelect: Select component to filter by safety diagnosis status (VALID / INVALID)
 */
const WorkorderSafetyDiagSelect = (props: WorkorderSafetyDiagSelectProps) => {
  const [safetyDiagListState, setSafetyDiagListState] = useState<any[]>([]);
  const [valueState, setValueState] = useState<any>(null);

  useEffect(() => {
    const list = ["VALID", "INVALID"];

    setSafetyDiagListState(
      list.map((e) => ({
        value: e,
        label: t("workorder:filters:safetyDiag:" + e.toLowerCase(), e === "VALID" ? "Valide" : "Invalide"),
      }))
    );

    if (props.value && props.value.length > 0) {
      setValueState(
        props.value.map((val) => ({
          value: val,
          label: t("workorder:filters:safetyDiag:" + val.toLowerCase(), val === "VALID" ? "Valide" : "Invalide"),
        }))
      );
    } else {
      setValueState(null);
    }
  }, [props.value]);

  const safetyDiagChange = (value: any) => {
    setValueState(value);
    if (props.onChange) {
      props.onChange(
        value ? value.map((val: { value: string; label: string }) => val.value) : []
      );
    }
  };

  return (
    <div className="flex w-full min-w-0">
      <MultiCheckSelect
        options={safetyDiagListState}
        value={valueState}
        theme={reactSelectTheme}
        onChange={safetyDiagChange}
        name="safetyDiagStatus"
        placeholder={t("workorder:filters:safetyDiag:placeholder", "Sélectionner au moins un résultat")}
        className="min-w-0 w-full"
        isDisabled={props.disabled}
      />
    </div>
  );
};

export default WorkorderSafetyDiagSelect;
